import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  SCHEDULE_PAUSE_SCHEDULE_BEGIN,
  SCHEDULE_PAUSE_SCHEDULE_SUCCESS,
  SCHEDULE_PAUSE_SCHEDULE_FAILURE,
  SCHEDULE_PAUSE_SCHEDULE_DISMISS_ERROR,
} from './constants';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function pauseSchedule(args = {}) {
  return (dispatch) => {
    dispatch({
      type: SCHEDULE_PAUSE_SCHEDULE_BEGIN,
    });
    const { projectId, taskId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      let url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/schedules/${taskId}/pause`;
      const doRequest = axios.post(url, {}, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: SCHEDULE_PAUSE_SCHEDULE_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: SCHEDULE_PAUSE_SCHEDULE_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err);
          toast.error(`Pause Failed: ${errMsg}`);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissPauseScheduleError() {
  return {
    type: SCHEDULE_PAUSE_SCHEDULE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SCHEDULE_PAUSE_SCHEDULE_BEGIN:
      return {
        ...state,
        pauseSchedulePending: true,
        pauseScheduleError: null,
      };

    case SCHEDULE_PAUSE_SCHEDULE_SUCCESS:
      return {
        ...state,
        pauseSchedulePending: false,
        pauseScheduleError: null,
      };

    case SCHEDULE_PAUSE_SCHEDULE_FAILURE:
      return {
        ...state,
        pauseSchedulePending: false,
        pauseScheduleError: action.data.error,
      };

    case SCHEDULE_PAUSE_SCHEDULE_DISMISS_ERROR:
      return {
        ...state,
        pauseScheduleError: null,
      };

    default:
      return state;
  }
}
